import { put, getContext } from 'redux-saga/effects';
import { StatusCodes } from 'http-status-codes';
import { timezoneSlice } from '../reducer';
import { TIMEZONES_API_HOST, HTTP_PROTOCOL } from '../../../constants';
export function* fetchTimezonesHandler() {
  try {
    yield put(timezoneSlice.actions.setTimezonesLoading(true));
    var timezonesHost = yield getContext(TIMEZONES_API_HOST);
    var protocol = yield getContext(HTTP_PROTOCOL);
    var response = yield fetch("".concat(protocol, "://").concat(timezonesHost, "/timezones"));

    if (response.status === StatusCodes.OK) {
      var timezones = yield response.json();
      var timezonesCollection = timezones.map(function (timezone) {
        return {
          name: timezone.name,
          numberOfSecondsToOffsetTime: timezone.number_of_seconds_to_offset_time,
          utcOffset: timezone.utc_offset
        };
      });
      yield put(timezoneSlice.actions.setTimezones(timezonesCollection));
    } else {
      yield put(timezoneSlice.actions.setError(true));
    }
  } catch (err) {
    yield put(timezoneSlice.actions.setError(true));
  } finally {
    yield put(timezoneSlice.actions.setTimezonesLoading(false));
  }
}